/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ volumeCutPct: NonNullable<unknown> }} Progression_Feedback_Low_EnergyInputs */

const en_us2_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Two drained sessions: ${i?.volumeCutPct}% fewer sets next time`)
};

const pt_br2_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duas sessões exaustivas: ${i?.volumeCutPct}% menos séries na próxima`)
};

const es_419_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dos sesiones agotadoras: ${i?.volumeCutPct}% menos series la próxima vez`)
};

const pt_pt2_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duas sessões exaustivas: menos ${i?.volumeCutPct}% de séries na próxima`)
};

const fr_fr2_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deux séances épuisantes : ${i?.volumeCutPct} % de séries en moins la prochaine fois`)
};

const de_de2_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zwei kraftlose Einheiten: nächstes Mal ${i?.volumeCutPct}% weniger Sätze`)
};

const it_it2_progression_feedback_low_energy = /** @type {(inputs: Progression_Feedback_Low_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Due sessioni senza energie: ${i?.volumeCutPct}% di serie in meno la prossima volta`)
};

/**
* | output |
* | --- |
* | "Two drained sessions: {volumeCutPct}% fewer sets next time" |
*
* @param {Progression_Feedback_Low_EnergyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_feedback_low_energy = /** @type {((inputs: Progression_Feedback_Low_EnergyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Feedback_Low_EnergyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_feedback_low_energy(inputs)
	if (locale === "es-419") return es_419_progression_feedback_low_energy(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_feedback_low_energy(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_feedback_low_energy(inputs)
	if (locale === "de-DE") return de_de2_progression_feedback_low_energy(inputs)
	if (locale === "it-IT") return it_it2_progression_feedback_low_energy(inputs)
	return en_us2_progression_feedback_low_energy(inputs)
});
export { progression_feedback_low_energy as "progression.feedback_low_energy" }